module.exports = __webpack_public_path__ + "img/Qlogo.861c8a72.png";